import type { FaireProductEntity } from "../../entity_types/product";

export const p_kqxpxjnydk: FaireProductEntity = {
  token: "p_kqxpxjnydk",
  type: "product",
  name: "Retro Checkerboard Raw Hem Denim Shorts",
  brandToken: "b_elccldtdr7",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/8c4cc68558ce1c05c658651b752201a705eab8be57f08ff6d8d5de22ee106287.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0847bef3e5df891a255c168c67f4a18cf24684a7b73d7d1dac16d5a177e8dca7.jpeg",
    "https://cdn.faire.com/fastly/8020e00428df97aa6c18d797e36345d254f8e0cebf6b6076d36f255236183443.jpeg",
    "https://cdn.faire.com/fastly/7311e0dd57967b95d465a8e435acde1e02d52a616c52b96ba23f469ae31ef2de.jpeg",
    "https://cdn.faire.com/fastly/c1d2c079335546e62f4af8e809404c83e200e46c2c2c00e1eec836da39ba8e02.jpeg",
    "https://cdn.faire.com/fastly/4f86c8d4ac477351f0ce57a20851e904ace099d827a8682d06dd15c431c6a686.jpeg",
    "https://cdn.faire.com/fastly/535c4d35c35fb75b439b0d0306e8f87691bed4c199b4efc737ecdeb55147fedf.jpeg",
    "https://cdn.faire.com/fastly/9bea1938ba973bfbcb2de16c2c346f556b0cf982d7347c65b4e559d9c747f7f8.jpeg",
    "https://cdn.faire.com/fastly/6fbfd3bd01480be110d00cb224f730cc8a2f34ebeaf85f3db413573380b982b4.jpeg",
    "https://cdn.faire.com/fastly/5ef91d78f6d8a1b6a6746422f93b078a3b8b308060def775d2c4759acabc3e1a.jpeg",
    "https://cdn.faire.com/fastly/3a621be85a6f2e7270add3eea5277b28f19ad5b8792069cffdff3cdcce01d6c7.jpeg",
    "https://cdn.faire.com/fastly/ad8632d99031f0dd58790419e1146a398c44adad40bdab40c7e3b976a4e8e909.jpeg",
    "https://cdn.faire.com/fastly/333b69c2abb694821e31612b8bd06040801e42f55af0512ee6e96e665105d774.jpeg",
    "https://cdn.faire.com/fastly/a9b206e259ec8581c9f4d45f04e249603bf9bf2f321563ad27d1533b98676858.jpeg",
    "https://cdn.faire.com/fastly/1c979f25ddaa012c2d71dc8e9de97adb9031a65490d432dc85c2e3491a89dba2.jpeg",
    "https://cdn.faire.com/fastly/85b0351f5f8ce28f5508db64b0f48e6042680fb8607d799825ded09347e8ff7b.jpeg",
  ],
  priceDollars: 31.86,
  description:
    'Capture the high-demand Y2K and streetwear markets with these bold checkerboard denim shorts. Serving major retro racing and skater vibes, these high-waisted shorts feature utilitarian patch pockets and a trendy frayed hem. They are the ultimate statement bottoms for festival season, concerts, or standout everyday casual wear, easily paired with basic crops or oversized graphic tees.\n\nProduct Details:\n\nDesign: A high-waisted denim short with a classic front button and zip-fly closure.\n\nPattern & Colors: Features a striking, all-over checkerboard print.\n\nPockets: Upgraded from standard denim pockets to large, utilitarian front and back patch pockets, adding a cool, carpenter-style aesthetic.\n\nHem: Finished with a casual, raw/frayed edge hem for an authentic "lived-in" vintage look.\n\nMaterial: 100% Cotton \n\nSizing Pack: Sold in a 3-2-1 pack (3 Small, 2 Medium, 1 Large).\n\nOrigin: Made in China.',
  tags: [],
  msrpDollars: 63.71,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:00.428Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
